import styled from 'styled-components'

const SelectStyled = styled.div``
export default SelectStyled
